//==========================================================================
//common.js
//==========================================================================

//userAgent
//---------------------------------------------------------
function userAgent() {
  const ua = navigator.userAgent;
  if (ua.indexOf('iPhone') != -1 || ua.indexOf('iPod') != -1 || ua.indexOf('Android') != -1 && ua.indexOf('Mobile') != -1) {
    //sp
    $('body').addClass('is-view-sp');
  } else if (ua.indexOf('iPad') != -1 || ua.indexOf('Android') != -1) {
    //tab
    $('body').addClass('is-view-tab');
  } else {
    // pc
    $('body').addClass('is-view-pc');
  }
}


//userAgentIE
//---------------------------------------------------------
function userAgentIE() {
  const ua = window.navigator.userAgent.toLowerCase();
  const uaVersion = window.navigator.appVersion.toLowerCase();
  //ie
  if (ua.indexOf('msie') != -1 || ua.indexOf('trident') !== -1) {
    $('body').addClass('is-view-ie');
  }
}


//sprite svg
//---------------------------------------------------------
function spriteSvg() {
  if (!window.shippingAssets || !window.shippingAssets.sprite) return;
  $.ajax({
    type: 'get',
    url: window.shippingAssets.sprite
  }).done(function(data) {
    var svg = $(data).find('svg');
    $('body').prepend(svg);
  });
}


//menu
//---------------------------------------------------------
function menu() {
  const $menuTrriger = $('.js-menu-trigger');
  const $menuTarget = $('.js-menu-target');
  const $menuBg = $('.js-menu-bg');
  const $menuClose = $('.js-menu-close-trigger');
  let scrollPosition;
  //menuTrriger
  $menuTrriger.on('click', function(){
    if(!$(this).hasClass('is-open')){
      $menuTrriger.addClass('is-open');
      $menuTarget.addClass('is-open');
      $menuBg.addClass('is-open');
      scrollPosition = $(window).scrollTop();
      $('body').addClass('is-locked').css({ 'top': -scrollPosition });
    } else {
      menuClose();
    }
  });
  //menuClose
  $menuClose.on('click', function(){
    menuClose();
  });
  //menuClose
  function menuClose () {
    $menuTrriger.removeClass('is-open');
    $menuTarget.removeClass('is-open');
    $menuBg.removeClass('is-open');
    $('body').removeClass('is-locked').css({ 'top': '' });
    window.scrollTo(0, scrollPosition);
  }
}


//drop down nav
//---------------------------------------------------------
function dropNav() {
  $('.js-drop-nav').hover(function() {
    $(this).toggleClass('is-drop-nav-active');
  });
}


//pagetop
//---------------------------------------------------------
function pagetop() {
  const pagetopTrigger = $('.js-pagetop');
  $(window).on('scroll', function() {
    scrollHeight = $(document).height();
    triggerHeight = pagetopTrigger.height();
    scrollPosition = window.innerHeight + $(window).scrollTop() + triggerHeight;
    footHeight = $('.l-footer').height();
    if (scrollHeight - scrollPosition  <= footHeight) {
      pagetopTrigger.removeClass('is-fixed');
    } else {
      pagetopTrigger.addClass('is-fixed');
    }
  });
  pagetopTrigger.click(function () {
    $('body,html').animate({
      scrollTop: 0
    }, 500);
    return false;
  });
}


// anker
// ---------------------------------------------------
function anker() {
  const headerHeight = $('.l-header').outerHeight();
  $('.js-anker[href^="#"]').click(function () {
    let href = $(this).attr('href');
    let target = $(href == "#" || href == "" ? 'html' : href);
    let position = target.offset().top - headerHeight;
    $('html, body').animate({
      scrollTop: position
    },500);
    return false;
  });
}


//animation
//---------------------------------------------------------
function scrollAnimation() {
  const animationTarget = $('.js-animate');
  animationTarget.addClass('is-animate');
  $(window).on('load scroll', function(){
    animationTarget.each(function(){
      let targetPos = $(this).offset().top;
      let scroll = $(window).scrollTop();
      let windowHeight = $(window).height();
      if (scroll > targetPos - windowHeight + 100){
        $(this).addClass('is-animated');
      }
    });
  });
}


//accordion
//---------------------------------------------------------
function accordion() {
  $('.js-accordion').on('click', function() {
    $(this).toggleClass('is-active').next().stop().slideToggle(300);
    return false;
  });
}

function modal() {
  var scrollpos;

  // Use event delegation to handle dynamically created elements
  $(document).on('click', '.js-modal', function(e) {
      e.preventDefault();
      var id = $("#" + $(this).attr("data-id"));

      // Close any currently open modal before opening a new one
      var $openModal = $('.p-modal.active');
      if ($openModal.length && !$openModal.is(id)) {
          $openModal.removeClass('active');
      }

      // Only update scroll position if no modal was open before
      if (!$openModal.length) {
          scrollpos = $(window).scrollTop();
          $('html').addClass('freezePage');
          $('body').addClass('freezePage').css({
              'top': -scrollpos
          });
      }

      id.addClass('active');
      id.find('.p-modal-dialog').scrollTop(0);
  });

  // Outside-click-to-close: click on modal backdrop (not dialog) closes modal
  // unless modal has 'no-outside-close' class
  $(document).on('click', '.p-modal.active', function(e) {
      var $modal = $(this);
      if ($modal.hasClass('no-outside-close')) return;
      // Only close if click is directly on the backdrop, not on modal dialog content
      if (e.target !== this) return;
      $modal.find('.js-close').first().trigger('click');
  });

  // Escape key: close topmost modal and unfreeze page
  $(document).on('keydown', function(e) {
      if (e.key !== 'Escape' && e.keyCode !== 27) return;
      var $active = $('.p-modal.active');
      if (!$active.length) {
          // No modal open but page still frozen — emergency unfreeze
          if ($('body').hasClass('freezePage')) {
              var savedPos = parseInt($('body').css('top') || '0', 10) * -1 || scrollpos || 0;
              $('html').removeClass('freezePage');
              $('body').removeClass('freezePage').css({ 'top': 0 });
              window.scrollTo(0, savedPos);
          }
          return;
      }
      var $topModal = $active.last();
      if ($topModal.hasClass('no-outside-close')) return;
      $topModal.find('.js-close').first().trigger('click');
  });

  $(document).on('click', '.js-close', function(e) {
      e.preventDefault();
      var $parentModal = $(this).closest('.p-modal');
      var $activeModals = $('.p-modal.active');
      // If multiple modals are stacked, only close the topmost one and keep others
      if ($parentModal.length && $activeModals.length > 1) {
          $parentModal.removeClass('active');
          return;
      }
      $('.p-modal').removeClass('active');
      var savedPos = parseInt($('body').css('top') || '0', 10) * -1 || scrollpos || 0;
      $('html').removeClass('freezePage');
      $('body').removeClass('freezePage').css({
          'top': 0
      });
      window.scrollTo(0, savedPos);
  });

}
//init
//---------------------------------------------------------
$(function(){
  userAgent();
  userAgentIE();
  spriteSvg();
  menu();
  dropNav();
  pagetop();
  anker();
  scrollAnimation();
  accordion();
  modal()
});










